import {Component, Injector, Input, OnInit} from '@angular/core';
import {IManagableObject} from "../../IManagableObject";
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {DriversService} from "../../../../services/drivers.service";
import {KeysService} from "../../../../services/keys.service";
import { DriversViewModel} from "../models/DriversViewModel";

@Component({
    selector: 'app-drivers-dialog-base',
    templateUrl: './drivers-dialog-base.component.html',
    styleUrls: ['./drivers-dialog-base.component.css'],
    standalone: false
})
export class DriversDialogBaseComponent extends DialogBaseComponent<DriversViewModel> implements OnInit {

  @Input()
  public groups: IManagableObject[] = [];

  @Input()
  public keys: IManagableObject[] = [];
  protected keysService: KeysService;
  protected service: DriversService;

  constructor(protected injector: Injector) {
    super(injector);
    this.service = injector.get(DriversService);
    this.keysService = injector.get(KeysService);
  }


  ngOnInit() {
    super.ngOnInit();
    this.keysService.GetKeys().subscribe(keys => {
      this.keys = keys;
    });
    this.service.GetGroups().subscribe(groups => {
      this.groups = groups;
    });
  }

  show(id:number) {
    this.model = new DriversViewModel();
    this.service.GetAllDrivers()
      .subscribe(drivers => {
        this.model = drivers.find(d => d.Id == id);
        if (this.model == undefined) return;
        this.open(this.model);
      })
  }


  open(model: DriversViewModel, type: { new(): DriversViewModel } = undefined) {
    super.open(model, type);
    if (model.Id > 0) {
      /*this.service.GetDriverGroup(model.Id).subscribe(groups => {
        model.Groups = groups.map(g => g.Id);
      });*/
      /*this.service.GetDriverKeys(model.Id).subscribe(keys => {
        model.Keys = keys.map(g => g.Id);
      });*/
    }
  }
}
